import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
const Component = props => {
  return _jsx(_Fragment, {
    children: _jsxs("svg", Object.assign({
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props, {
      children: [_jsxs("g", {
        clipPath: "url(#bl6p0mhwa__clip0_1_5400)",
        children: [_jsx("rect", {
          width: "20",
          height: "20",
          rx: "10",
          fill: "white"
        }), _jsxs("g", {
          clipPath: "url(#sul5py5pg__clip1_1_5400)",
          children: [_jsx("path", {
            d: "M22 3H-2V17H22V3Z",
            fill: "white"
          }), _jsx("path", {
            d: "M10.0001 14.2C12.2368 14.2 14.0501 12.3196 14.0501 9.99999C14.0501 7.68039 12.2368 5.79999 10.0001 5.79999C7.76332 5.79999 5.95007 7.68039 5.95007 9.99999C5.95007 12.3196 7.76332 14.2 10.0001 14.2Z",
            fill: "#BC002D"
          })]
        })]
      }), _jsx("rect", {
        x: "0.5",
        y: "0.5",
        width: "19",
        height: "19",
        rx: "9.5",
        stroke: "#152361"
      }), _jsxs("defs", {
        children: [_jsx("clipPath", {
          id: "bl6p0mhwa__clip0_1_5400",
          children: _jsx("rect", {
            width: "20",
            height: "20",
            rx: "10",
            fill: "white"
          })
        }), _jsx("clipPath", {
          id: "sul5py5pg__clip1_1_5400",
          children: _jsx("rect", {
            width: "24",
            height: "14",
            fill: "white",
            transform: "translate(-2 3)"
          })
        })]
      })]
    }))
  });
};
export default Component;
